import { BaseAPIService } from "./base";
import { ParamsService } from "./params";

export class ComponentService {
    BASE_SERVICE = BaseAPIService.getInstance();

    /**
    * Method is using for creating solution component item in database.
    * @param params
    * @returns solution component id or rises Error
    */
    async create(params) {
        try {
            const urlWithParams = '/solution_component/new?';
            const paramsService = new ParamsService(
                urlWithParams,
                params
            );
            const url = paramsService.urlWithParams;
            const data = await this.BASE_SERVICE.post(
                {
                    url: url,
                    body: {},
                }
            );
            return data.component_id;
        } catch (e) {
            throw new Error(e.message);
        }
    };

    /**
    * Method is using for updating all solution component items in database.
    * @param componentId
    * @param data
    * @returns "OK" message or rises Error
    */
    async update(componentId, data) {
        try {
            await this.BASE_SERVICE.put(
                {
                    url: `/solution_component/${componentId}`,
                    body: data,
                }
            );
            return "OK";
        } catch (e) {
            throw new Error(e.message);
        }
    };

    /**
    * Method is using for getting all solution component items from database by solutionId id.
    * @param solutionId
    * @returns list of solution components or rises Error
    */
    async getAllBySolutionId(solutionId) {
        try {
            const data = await this.BASE_SERVICE.get(
                {
                    url: `/solution_component/all/filter_by?&solution_id=${solutionId}`,
                }
            );
            return data;
        } catch (e) {
            throw Error(e);
        }
    };

    /**
    * Method is using for getting all solution component items from database by workspaceId.
    * @param workspaceId
    * @returns list of solution components or rises Error
    */
         async getAllByWorkspaceId(workspaceId) {
            try {
                const data = await this.BASE_SERVICE.get(
                    {
                        url: `/solution_component/all/filter_by?&workspace_id=${workspaceId}`,
                    }
                );
                return data;
            } catch (e) {
                throw Error(e);
            }
        };

    /**
     * Method is using for deleting solution component item from database.
     * @param componentId
     * @returns "OK" message or rises Error
     */
    async delete(componentId) {
        try {
            await this.BASE_SERVICE.delete(
                {
                    url: `/solution_component/${componentId}`,
                }
            );
            return "OK";
        } catch (e) {
            throw Error(e);
        }
    };
};
